export default (cnpj = "") => {
  const cnpjLimpo = globalThis.$utils.cpfCnpjMask(cnpj, true);
  if (cnpjLimpo.length !== 14) return false;

  const base = cnpjLimpo.substring(0, 12);
  const dvInformado = cnpjLimpo.substring(12);

  function calcularDV(texto, pesos) {
    let soma = 0;
    for (let i = 0; i < texto.length; i++) {
      const valor = texto.charCodeAt(i) - 48;
      soma += valor * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  }

  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const dv1 = calcularDV(base, pesos1);

  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const dv2 = calcularDV(base + dv1, pesos2);

  return dvInformado === `${dv1}${dv2}`;
};
